import { computed, inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * Lee los permisos de la sesión actual.
 *
 * Ojo: esto controla lo que se muestra, no lo que se puede hacer. La validación
 * real tiene que vivir en el gateway; aquí sólo se evita ofrecer opciones que el
 * usuario no puede usar.
 */
@Injectable({ providedIn: 'root' })
export class PermissionsService {
  #auth = inject(AuthService);

  readonly permissions = computed(() => this.#auth.currentUser()?.permissions ?? []);

  /** El rol SuperAdmin usa el comodín '*', que concede todo. */
  can(key: string): boolean {
    const permissions = this.permissions();
    return permissions.includes('*') || permissions.includes(key);
  }
}
